
<div class="otp-input-container margin-top-bottom">
    <form  class="text-center">
        <input matInput #formRow *ngFor="let control of otpForm.controls;let idx = index"
         type="text" [formControl]="control" maxlength="1" (keyup)="keyUpEvent($event, idx)"
         class="otp-input mat-icon-buttons margin-right font-28 text-center" appInputRegex [pattern]="NumbersOnly">
    </form>
</div>
 